<template>
  <div>
    <div class="centered-column">
      <div class="container-header">
        <h3>{{ label.get('job_codes') }}</h3>
      </div>

      <div class="white-card">
        <div class="white-card-header">
          <div class="title-wrap">
            <label class="title-label">{{label.get('preference')}}</label>
          </div>
        </div>
        <div class="toggle-dep no-border job-codes-toggle-dep">
          <div class="check-wrapper switch-wrapper job-codes-switch">
            <b-form-checkbox
                v-model="requireJobOnClockIn"
                @change="changeJobClockInReminder"
                :disabled="!jobCodes.length"
            >
              {{ label.get('job_codes_require_job_on_clock_in') }}
            </b-form-checkbox>
            <p class="disclaimer">
              {{ label.get('job_codes_require_job_on_clock_in_description') }}
            </p>
          </div>
        </div>
      </div>

      <div class="white-card">
        <div class="white-card-header">
          <div class="title-wrap">
            <label class="title-label">{{ label.get('job_codes') }}</label>
          </div>
          <button
              class="add-new-btn"
              @click="addJobCodes"
              v-if="jobCodes.length"
          >
            <i class="atto atto-add-more" />
            {{ label.get('add_job_code') }}
          </button>
        </div>
        <div class="list-container" v-if="jobCodes.length">
          <div class="table-heading">
          <span class="heading-label jc">
            {{ label.get('name') }}
          </span>
          </div>
          <ul>
            <li
                v-for="(item, idx) in jobCodes"
                :key="idx"
            >

              <i class="atto atto-jobs setting-icon" />
                  <span class="name">
                    {{ item.name }}
                  </span>
                <div class="options">
                  <button
                      class="edit-job edit-btn"
                      @click="editJobCode(item)"
                  >
                    <i class="atto atto-edit-btn" />
                  </button>
                  <button
                      class="delete-job delete-btn"
                      @click="deleteJobCode(item)"
                  >
                    <i class="atto atto-delete" />
                  </button>
                </div>

            </li>
          </ul>
        </div>
        <div v-if="!jobCodes.length">
          <div class="no-items">
            <div class="item-wrap">
              <i class="no-job-codes" />
              <button
                  class="atto-btn add-entry add-item"
                  @click="addJobCodes"
              >
                {{label.get('add_job_codes')}}
              </button>
              <p>
                {{label.get('when_you_add_a_job_code_desc')}}
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>

    <edit-job-code-component
        v-if="showEditJobCode"
        :job="jobItem"
    />
    <delete-job-code-component
        v-if="showDeleteJobCode"
        :job="jobItem"
    />
  </div>
</template>

<script>
  import EditJobCodeComponent from "./EditJobCodeComponent";
  import DeleteJobCodeComponent from './DeleteJobCodeComponent';
  import JobCodesService from "../services/JobCodesService";
  import CompanyService from "../../company/services/CompanyService";
  import AddJobCodeComponent from "./AddJobCodeComponent";

  export default {
    name: "AllJobCodesComponent",
    components: {AddJobCodeComponent, EditJobCodeComponent, DeleteJobCodeComponent},
    data (){
      return {
        requireJobOnClockIn: this.$store.state.companySettings.require_jobs_on_clock_in,
        showEditJobCode: false,
        showDeleteJobCode: false,
        jobItem: null,
      }
    },
    computed: {
      jobCodes() {
        return this.$store.state.companyJobs;
      }
    },
    mounted() {
      this.$root.$on('hideEditJobCode', this.hideEditJobCode);
      this.$root.$on('hideDeleteJobCode', this.hideDeleteJobCode);
    },
    created() {
      this.getJobCodes();
    },
    beforeDestroy() {
      this.$root.$off('onDeleteJobCode');
      this.$root.$off('hideNewJobCode');
    },
    methods: {
      getJobCodes() {
        JobCodesService.getJobCodes().then((response) => {
          this.$store.state.companyJobs = response;
        }).catch((error) => {
          console.log(this.label.get('error_loading_job_codes'));
        });
      },
      changeJobClockInReminder() {
        const _this = this;
        this.$store.state.companySettings.require_jobs_on_clock_in = !_this.requireJobOnClockIn;
        if(_this.debounce) {
          clearTimeout(_this.debounce);
        }

        _this.debounce = setTimeout(() => {
          CompanyService.updateCompanySettings(_this.$store.state.companySettings).then(() => { }).catch(() => { });
        }, 1000);
      },
      addJobCodes() {
        debugger;
        this.$root.$emit('showAddJobCode');
      },
      editJobCode(job) {
        this.jobItem = job;
        this.showEditJobCode = true;
      },
      deleteJobCode(job) {
        this.jobItem = job;
        this.showDeleteJobCode = true;
      },
      hideEditJobCode(job) {
        if(job) {
          const index = this.$store.state.companyJobs.indexOf(job);
          if(index >= 0) {
            this.$store.state.companyJobs[index].name = job.name;
          }
        }
        this.showEditJobCode = false;
        this.jobItem = null;
      },
      hideDeleteJobCode(job) {
        if(job) {
          const index = this.$store.state.companyJobs.indexOf(job);
          this.$store.state.companyJobs.splice(index, 1);
        }
        this.showDeleteJobCode = false;
        this.jobItem = null;
      },
    },
  }
</script>


<style lang="scss">
  .job-codes-switch.check-wrapper .custom-checkbox .custom-control-label{
    text-transform: none !important;
  }
  .job-codes-toggle-dep{
    margin: 0 36px;
    p{
      max-width: 430px;
      margin-top: 4px !important;
      color: #666666 !important;
    }
    .check-wrapper .custom-checkbox .custom-control-input:disabled ~ .custom-control-label{
      color: inherit;
    }
  }
</style>
